<template>
  <div class="mainbody" style="min-height: 40vw;">
      <PCNavbar selectIndex="4"/>
      <MobileNavBar :currentActive="3" />
      <!-- <img class="top-bg" src="../../assets/img3/yewubankuai1/xiandaiwuliu-title-bg.png" alt="" /> -->
      <img class="top-bg" src="../../assets/8.4/truckImg.png" alt="" />

      <div class="menus" v-scroll-animate="'slide-itemgk'" style="width: 90vw;margin:0 auto;">
          <a href="/home"><i class="el-icon-s-home"></i></a> / <a href="/businessDetail?title=%25E8%25BF%2590%25E8%25B4%25B8%25E4%25BA%25A7%25E8%259E%258D%25E5%2590%2588">运贸产融合</a>/板块详情
      </div>
    
         
      <div class="detailContainer">
        
       
        <!-- 模块1 -->
        <div class="childContent" >
           <!-- <h1>公司简介</h1> -->
           <div class="flexContainerDiv"> 
          
            <h1 v-if="this.queryIndex=='00'">河南港产运营管理有限公司</h1>
                <div class="detailDiv"> 
                  <p v-if="this.queryIndex=='00'" v-html="brief.content" class="detailDivP">
                    
                  </p>
                 
                   <!--  公司 -->
                   <div class="companyItemDiv"  v-for="(item,index) in companyList" :key="index"  :class="item.segmentIs">
                    <h1 class="companyTitle"> {{ item.company }}</h1>
                    
                    <p class="companyP detailDivPImg" v-html="item.content"></p>
                  
                    <p class="centerPcss0" v-if="item.imgList.length>0">
                     
                      <CarouselHomeyewubankuai  ref="carusel4" :imgList="item.imgList" :heightParam="heightParam" />
                    </p>
                  </div>
                 
                </div>
                <div class="imgDiv"> 
                    <!-- <img src="../../assets/img3/yewubankuai1/3.png" /> -->
                </div>
            </div>
         </div>



      </div>
   </div>
</template>

<script>
import API from '@/api/bsInfo'

import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHomeyewubankuai from '@/components/carousel_home/indexyewubankuai.vue'


export default {
 components: {
  PCNavbar,
  MobileNavBar,
  CarouselHomeyewubankuai
 },
 data() {
   return {
    urlBase: process.env.VUE_APP_BASE_API,

    companyList:[],
    heightParam:'32vw',
    queryIndex:null,
    
    id:null,
    brief:{},
    segmentsList:[],
   

   }
 },
 props: {
   
 },
 created() {
  this.queryIndex = this.$route.query.index;
  this.id = this.$route.query.id;
  
   this.getCompany()
   this.zhongoubanlieData()
},
 methods: {
   //获取上部分服务数据
async zhongoubanlieData() {
    try {
      let objParams={
        catId:'7c8b7951515f470bb087c29c2272eafb',
        type:1
      }
      const res = await API.zhongoubanlieData(objParams)
      this.$nextTick(()=>{
        this.zhongouData = res.data
        this.brief=res.data.brief
        this.segmentsList=res.data.segmentsList
       
        console.log('获取成功', res.data.resultData)
      })
     
    } catch (error) {
      console.error('获取失败', error)
    }
  },
   //获取公司数据
 async getCompany() {
    try {
      let objParams={}
      if(!!this.id){
         objParams={
          type:1,
          segmentIs:this.id
        }
      }else{
        objParams={
          type:1
        }
      }
     
      const res = await API.getCompany(objParams)
    
      this.$nextTick(()=>{
        this.companyList=res.data.companyList
        this.companyList.forEach(item=>{
            let imgarr=item.photo.split('|').slice(1)
            let imgList=[]
            imgarr.forEach(item1=>{
              imgList.push({
                        src: this.urlBase+item1,
                        line1: ' ',
                        line2: ' ',
                      })
            })
           
            item['imgList']=imgList
        })
        
        console.log('获取成功', res.data)
        
      })
     
    } catch (error) {
      console.error('获取失败', error)
    }
  },
  changeTargetPosition(id) {
    let objID=id
    const element = document.getElementsByClassName(objID)[0];
    element.scrollIntoView({ 
      behavior: 'smooth', // 平滑滚动
      block: 'start'      // 对齐到顶部（可选：'center'/'end'）
    });

   
   
  },
 },
}
</script>

<style lang="scss" scoped>

 .detailContainer{
  width: 90vw;
   margin:0 auto;
   border:1px solid #e5e5e5;
   padding-bottom:10rem;
   // background: #dde8f4;
   // margin-block: 100px;
   // background:url('../../assets/img3/gaikuang1/chanyepng.png');
 // background-size: 100% 100%;
 // .modules0{
 // 	width: 100%;
 // 	margin: 0 auto;
 // }
    
 }
//    .menus{
//     width: 90%;
//     margin:0 auto;
//   padding:1rem;
//   padding-left: 0;
//   font-size:1rem;
//   a{
//     color:#015293;
//   }
//  }

.childContent{
   width: 100%;
   margin:0 auto;
   margin-top: 1rem;
  //  border: 1px solid #000000;
   text-align: center;
   // background: #dde8f4;
   // margin-block: 100px;
   // background:url('../../assets/img3/gaikuang1/chanyepng.png');
 // background-size: 100% 100%;
 // .modules0{
 // 	width: 100%;
 // 	margin: 0 auto;
 // }
    h1{
      font-size: 1.2rem;
      line-height: 3rem;
      color: #333;
       
    }
    .flexContainerDiv{
      // display: flex;
      // gap: 2rem;
      .imgDiv{
      
         img{
          width: 100%;
          
         }
         div{
            width: 50%;
            img{
              display: block;
              width: 100%;
              height:4rem !important;
              object-fit: cover;
            }
          }
          div.imgDiv-1{
            width: 50%;
            img{
              display: block;
              width: 100%;
              height:12rem !important;
              object-fit: cover;
            }
          }
          div.imgDiv-2{
            img{
              height:6rem !important;
            }
          }
      }
      .detailDiv{
       
       text-align: left;
       font-size: 1rem;
      //  text-indent: 2rem;
       line-height: 2.5rem;
       color: #666666;
       ul{
        li{
          list-style: none;
          line-height: 2.5rem;
        }
       }
       h2,p{
        text-indent:2rem !important;
       }
       
       p.centerPcss0{
        text-indent:0rem !important;
        .carousel_wrap{
          width: 60vw;
          margin: 0 auto;
        }
       }
       
     }
    }
    

 }
 .contactMe{
  text-indent: 2rem;
 }
 .imgli{
  padding-top: 2rem;
  img{
    width:auto;
    height:10rem !important;
  }
 }
 ::v-deep{
  ul li{
    list-style: none !important;
  }
 }


// ::v-deep p {
//   text-indent: 2rem !important;
//   text-align: justify !important;
// }
.companyP{
  ::v-deep p {
    text-indent: 2rem !important;
    text-align: justify !important;
    margin-bottom: 0 !important;
  }
}
.companyItemDiv{
  h1.companyTitle{
    font-size: 1.2rem;
        line-height: 3rem;
        // color: #222;
        // text-decoration:underline;
        color: #fff;
        margin-bottom: 1rem !important;
        margin-top: 1rem !important;
        border-bottom: 1px solid #e5e9f5;
        background: #1969a5;
        box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
  }
}

 </style>